// Innovate Custom JS
$(document).ready(function(){
	console.log("Innovate Custom JS Loaded");
  	$('#cepas_container').slideUp();
  
  $(document).on('click', '#shop_btn', function(e){
  	e.preventDefault();
    $('#cepas_container').slideDown();
    
  });
  
  $(document).on('click', '.img_link', function(e){
    var link = e.target.getAttribute('link');
    
    setTimeout(function(){
    	window.location.href = link;
    }, 500)
    
  });
  
  if(window.location.href.includes('/collections/')){
    $(document).on('click', '.to-get-link', function(e){
      e.preventDefault();
      var link = e.target.children[0].children[0].children[0].getAttribute('link');
      
      window.location.href = link;      
      
    });
    
    $(".qtyBtn").on("click", function(e) {
      e.stopPropagation();
      var elem = jQuery(this);
      var oldValue = jQuery(this).closest('.qtyField').find('.qty').val();
      var newVal = 1;
      // console.log(elem, oldValue, newVal)
      if ( elem.hasClass("plus") ) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      jQuery(this).closest('.qtyField').find('.qty').val(newVal);
    });
  };
  

});